<!-- eslint-disable vue/no-undef-properties -->
<template>
  <Modal v-model:is-open="delete_modal_open" max-width="max-w-[600px] mx-5">
    <template #form="{}">
      <div class="max-w-xl mt-2 text-sm text-gray-500">
        <p>{{ $t("Are you sure you want to delete this component?") }}</p>
      </div>
      <div class="mt-5 text-center">
        <button
          type="button"
          class="inline-flex items-center justify-center px-4 py-2 font-medium text-red-700 bg-red-100 border border-transparent rounded-md hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:text-sm"
          @click="
            () => {
              deleteInstance(item_to_delete)
              delete_modal_open = false
            }
          ">
          {{ $t("Confirm Delete") }}
        </button>
        <button
          type="button"
          class="inline-flex items-center justify-center px-4 py-2 ml-2 font-medium border rounded-md dark:text-dark-body-text focus:outline-none focus:ring-2 focus:ring-offset-2 sm:text-sm"
          @click="delete_modal_open = false">
          {{ $t("Cancel") }}
        </button>
      </div>
    </template>
  </Modal>
  <div>
    <div class="mt-6 text-common-grey font-light">
      {{ $t("Components List") }}
    </div>
    <div ref="listContainer" class="max-h-[400px] relative overflow-auto overflow-x-hidden" @scroll="handleScroll">
      <div v-for="sub_component in componentList" :key="sub_component.id">
        <Disclosure
          v-if="
            !search_term ||
              sub_component.instances.filter((item) => item.props.component_props.label.toLowerCase().includes(search_term.toLowerCase()))
                .length ||
              sub_component.name.toLowerCase().includes(search_term.toLowerCase())
          "
          v-slot="{ open, close }"
          class="border-gray-100 border-2 mb-4 rounded-md"
          as="div">
          <div class="relative">
            <DisclosureButton
              class="flex justify-between w-full px-4 pb-2 font-medium text-left rounded-lg dark:hover:bg-dark-input-background focus:outline-none focus-visible:ring focus-visible:ring-blue-500 focus-visible:ring-opacity-75">
              <div
                :id="open ? `${sub_component.id}Disclosure2` : `${sub_component.id}Disclosure`"
                :ref="open ? `${sub_component.id}Disclosure2` : `${sub_component.id}Disclosure`"
                class="relative flex items-start duration-500 cursor-pointer transition-height hover:border-light-brand-blue hover:rounded-md w-full justify-between"
                @click="checkForOverlay">
                <div class="ml-2 mt-4 flex w-full justify-between">
                  <div
                    :class="[{ 'pointer-events-none': !sub_component.instances.length }]"
                    class="flex w-full font-normal dark:text-white gap-x-2">
                    <component
                      :is="sub_component.icon"
                      :color_1="sub_component.icon_color_1"
                      :color_2="sub_component.icon_color_2"
                      class="w-8 h-8 mr-5 mt-1 transition ease-in-out hover:text-dark-body-text text-common-grey duration-side-menu-transition-duration" />

                    <div class="leading-5">
                      <div class="!text-gray-900">
                        {{ sub_component.name }}
                      </div>

                      <div class="text-common-grey">
                        {{ sub_component.group_name }}
                        <span v-if="sub_component.settings?.title_extension?.length">
                          {{ `&#8226;` }}
                        </span>
                        {{ sub_component.settings?.title_extension?.join(" &#8226; ") }}
                      </div>
                    </div>
                  </div>

                  <div class="flex ml-auto z-50 gap-2">
                    <button v-if="sub_component.instances.length" class="btn cancel-btn">
                      <Activity class="mr-2 w-4 h-4" color="#899399" />
                      {{ sub_component.instances.length }} {{ $t("included") }}
                    </button>
                    <button
                      class="btn cancel-btn border-light-brand-blue text-light-brand-blue"
                      @click="addNewInstanceClick(sub_component)">
                      <Plus class="w-5 h-5 mr-2" /> {{ $t("Add") }}
                    </button>
                  </div>
                </div>
              </div>
            </DisclosureButton>
            <div v-if="!sub_component.instances.length && !open" class="w-[100%] absolute z-40 h-14 top-0 left-0 bg-transparent" />
            <DisclosurePanel
              :class="[
                {
                  'pb-32': component_to_add?.id == sub_component.id && sub_component.fields.length > 2
                },
                {
                  'pb-16': component_to_add?.id == sub_component.id && sub_component.fields.length <= 2
                }
              ]"
              class="px-4 pt-4 overflow-hidden">
              <div
                v-for="item in search_term
                  ? sub_component.instances.filter((item) =>
                    item.props.component_props.label.toLowerCase().includes(search_term.toLowerCase())
                  )
                  : sub_component.instances"
                :key="item.id"
                :class="[
                  {
                    'pb-32':
                      instance_to_edit?.component_id == sub_component.id &&
                      instance_to_edit?.id == item.id &&
                      sub_component.fields.length > 2
                  }
                ]"
                class="flex items-start justify-between p-3 border-b dark:border-b-dark-divider-border ml-2 gap-1">
                <div
                  :class="[
                    {
                      hidden: instance_to_edit?.component_id == sub_component.id && instance_to_edit?.id == item.id
                    }
                  ]">
                  <div class="text-medium dark:text-white ml-10">
                    {{
                      item.props.component_props[sub_component.fields[0].component_prop_name] == "this_record"
                        ? $t("This Record")
                        : item.props.component_props[sub_component.fields[0].component_prop_name] == "another_record"
                          ? $t("Showing for:")
                          : item.props.component_props[sub_component.fields[0].component_prop_name]
                    }}
                  </div>
                  <div class="flex w-full space-x-10">
                    <div
                      v-for="(field, i) in sub_component.fields"
                      :key="field.component_prop_name"
                      class="flex flex-row items-start justify-start">
                      <div v-if="i && item.props.component_props[field.component_prop_name]" class="dark:text-white">
                        <div
                          v-if="
                            field.linked_field ? item.props.component_props[field.linked_field] == field.linked_field_value_to_show : true
                          "
                          class="text-common-grey">
                          {{ field.label }}:
                        </div>
                        <span v-if="Array.isArray(item.props.component_props[field.component_prop_name])">
                          <span
                            v-for="(value, i) in item.props.component_props ? item.props.component_props[field.component_prop_name] : []"
                            :key="value"
                            class="mr-1">
                            {{ field.options?.find((f) => f[field.value_attr] == value)[field.label_attr]
                            }}{{ i < item.props.component_props[field.component_prop_name]?.length - 1 ? ", " : "" }}
                          </span>
                        </span>

                        <span v-else-if="field.options">
                          {{
                            field.options.find((f) => f[field.value_attr] == item.props.component_props[field.component_prop_name])
                              ? field.options.find((f) => f[field.value_attr] == item.props.component_props[field.component_prop_name])[
                                field.label_attr
                              ]
                              : null
                          }}</span>
                        <span
                          v-else-if="
                            field.linked_field ? item.props.component_props[field.linked_field] == field.linked_field_value_to_show : false
                          ">
                          <Avatar
                            :first-name="full_records[item.props.component_props[field.component_prop_name]]?.name[0]"
                            :last-name="null" />
                          <span class="ml-2">{{ full_records[item.props.component_props[field.component_prop_name]]?.name }} </span>
                        </span>
                        <span v-else-if="field.type == 'actions_filter'">{{
                          $utils.isEmpty(item.props.component_props[field.component_prop_name]) ? $t("Not applied") : $t("Applied")
                        }}</span>
                        <span v-else-if="field.type == 'date_input'">{{
                          $moment(item.props.component_props[field.component_prop_name]).format("DD MMM  YYYY")
                        }}</span>
                        <span v-else>{{ item.props.component_props[field.component_prop_name] }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="$utils.isEmpty(instance_to_edit) && !component_to_add" class="flex space-x-2">
                  <div
                    :class="[{ 'opacity-40 pointer-events-none has-tooltip': item.fixed }]"
                    class="cursor-pointer border rounded-md p-2 hover:bg-gray-200"
                    @click="handleInstanceVisibleClick(item)">
                    <Eye v-if="!item.props.hidden" color="#27C884" />
                    <EyeOff v-else color="#FF4D69" />
                    <span
                      class="tooltip whitespace-nowrap inline-flex items-center px-2 py-1 rounded-md text-sm w-[80px] bg-light-screen-background dark:bg-dark-screen-background font-medium dark:text-dark-body-text gap-2">
                      {{ $t("Cannot be hidden") }}</span>
                  </div>
                  <div class="cursor-pointer border rounded-md p-2 hover:bg-gray-200" @click="handleInstanceToEdit(item, sub_component.id)">
                    <Pencil class="w-5 h-5" :class="[{ 'text-white': $store.state.ui.darkMode }]" />
                  </div>
                  <div
                    :class="[{ 'opacity-40 pointer-events-none has-tooltip': item.fixed }]"
                    class="cursor-pointer border rounded-md p-2 hover:bg-gray-200"
                    @click="handleInstanceleDelete(item)">
                    <Trash2 class="w-5 h-5" :class="[{ 'text-white': $store.state.ui.darkMode }]" />
                    <span
                      class="tooltip whitespace-nowrap inline-flex items-center px-2 py-1 rounded-md text-sm w-[80px] bg-light-screen-background dark:bg-dark-screen-background font-medium dark:text-dark-body-text gap-2">
                      {{ $t("Cannot be deleted") }}</span>
                  </div>
                </div>

                <div v-if="instance_to_edit?.component_id == sub_component.id && instance_to_edit?.id == item.id" class="flex w-full gap-2">
                  <div class="flex flex-1 w-full">
                    <div class="grid grid-cols-2 gap-x-4 gap-y-4">
                      <div
                        v-for="field in sub_component.fields"
                        :key="field.component_prop_name"
                        class="col-span-1"
                        :class="{ 'col-span-2': field.column_full_span }">
                        <TextInput
                          v-if="field.type == 'text_input'"
                          :validate-on-input="true"
                          :value="instance_to_edit[field.component_prop_name]"
                          label=""
                          :classes="'w-full'"
                          input-classes="appearance-none block w-full px-3 py-2 h-[40px] border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
                          name="name"
                          type="text"
                          :placeholder="field.label"
                          @update:modelValue="
                            (e) => {
                              instance_to_edit[field.component_prop_name] = e
                            }
                          " />

                        <MultiSelectInput
                          v-else-if="field.type == 'multi_select'"
                          v-model:current-items="instance_to_edit[field.component_prop_name]"
                          :is-box-background="true"
                          :value="instance_to_edit[field.component_prop_name]"
                          name="selected_options"
                          :items="field.options"
                          :label-attr="field.label_attr"
                          :value-attr="field.value_attr"
                          :allow-null="true"
                          :label="field.label"
                          input-classes="sm:text-sm appearance-none font-medium text-gray-700 text-left block w-full px-3 py-[6px] border border-gray-300 rounded-md shadow-sm bg-white focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light dark:border-dark-divider-border dark:bg-dark-box-background"
                          :selection-text="null"
                          :placeholder="field.label"
                          class="w-full flex flex-col justify-between"
                          :show-label="false" />

                        <ComboBoxInput
                          v-else-if="field.type == 'multi_select_search'"
                          v-model="instance_to_edit[field.component_prop_name]"
                          :disabled="field.default_value"
                          :value="instance_to_edit[field.component_prop_name]"
                          name="selected_options_2"
                          :return-value="true"
                          :items="field.options"
                          :create-group-action="field.create_group_action"
                          :object-type="sub_component.settings?.object_type_confined"
                          :label-attr="field.label_attr"
                          :value-attr="field.value_attr"
                          :allow-null="true"
                          :is-box-background="true"
                          :label="field.label"
                          class="absolute w-1/5"
                          input-classes="sm:text-sm appearance-none font-medium text-gray-700 text-left block w-full px-3 py-2 h-[40px] border border-gray-300 rounded-md shadow-sm  focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light dark:border-dark-divider-border dark:bg-dark-box-background"
                          :placeholder="field.label" />

                        <SelectDropDownMenu
                          v-else-if="field.type == 'select'"
                          v-model:current-item="instance_to_edit[field.component_prop_name]"
                          :disabled="field.disabled"
                          name="select_input"
                          :allow-null="false"
                          :items="
                            field.filter_based_on
                              ? field.options.filter((o) => o[field.filter_field] == instance_to_edit[field.filter_based_on])
                              : field.options
                          "
                          :create-group-action="field.create_group_action"
                          :object-type="sub_component.settings?.object_type_confined"
                          :label-attr="field.label_attr"
                          :value-attr="field.value_attr"
                          :placeholder="field.label"
                          :label="field.label"
                          :show-label="false"
                          :use-floating-label="false"
                          class="w-full flex flex-col justify-between"
                          :input-classes="`w-full sm:text-sm appearance-none font-medium text-gray-700 text-left block px-1 py-2 h-[40px] rounded-lg shadow-sm bg-white focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light`" />
                        <div
                          v-else-if="
                            field.type == 'company_select' &&
                              (field.linked_field ? instance_to_edit[field.linked_field] == field.linked_field_value_to_show : true)
                          "
                          class="w-full flex flex-col justify-between">
                          <CompaniesSelect
                            :open-to-top="false"
                            :short-king="true"
                            :alternate-design="false"
                            :type-filter="$route.name == 'CompanyProfile' ? $route.params?.object_type : field.type_filter"
                            :multi-select="false"
                            :disabled="field.disabled"
                            :companies="instance_to_edit[field.component_prop_name] ? [instance_to_edit[field.component_prop_name]] : []"
                            :label="field.label"
                            @changed="
                              ($event) => {
                                if ($event) instance_to_edit[field.component_prop_name] = $event[0]?.id
                              }
                            " />
                        </div>
                        <div v-else-if="field.type == 'date_input'" class="rounded-md shadow-sm">
                          <DatePicker
                            v-model="instance_to_edit[field.component_prop_name]"
                            :is-dark="$store.state.ui.darkMode"
                            class="bg-white dark:bg-dark-screen-background"
                            is-inline
                            mode="date"
                            :popover="{ visibility: 'click' }">
                            <template #default="{ inputValue, inputEvents }">
                              <div class="relative">
                                <svg
                                  fill="none"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                  class="absolute w-4 h-full mx-2 text-gray-600 pointer-events-none">
                                  <path d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                </svg>

                                <input
                                  id="f_date"
                                  :value="inputValue"
                                  :placeholder="field.label"
                                  autocomplete="off"
                                  class="bg-light-screen-background dark:bg-dark-box-background w-full h-10 px-10 pl-8 pr-2 transition ease-in-out border rounded-lg outline-none text-light-body-text dark:text-dark-body-text border-light-divider-border dark:border-dark-divider-border focus:ring-1 focus:outline-none focus:ring-light-brand-blue dark:focus:ring-dark-brand-blue focus:border-light-brand-blue dark:focus:border-dark-brand-blue duration-side-menu-transition-duration"
                                  v-on="inputEvents">
                              </div>
                            </template>
                          </DatePicker>
                        </div>

                        <div
                          v-else-if="field.type == 'color_selector'"
                          class="space-x-2 items-center !w-full flex flex-col justify-between z-30">
                          <ColorPickerList v-model:current-item="instance_to_edit[field.component_prop_name]" :label="field.label" />
                        </div>

                        <ActionsFilter
                          v-else-if="field.type == 'actions_filter'"
                          :dynamic-data-source="field.dynamic_data_source"
                          :hide-range-selection="instance_to_edit.component_id.includes('calendar')"
                          :workspace-record="field.workspace_record"
                          :selected-actions="instance_to_edit?.view_by"
                          :initial-filter="instance_to_edit[field.component_prop_name]"
                          @change="instance_to_edit[field.component_prop_name] = $event" />

                        <div v-else-if="field.type == 'boolean'" class="flex items-center mt-4 gap-x-2">
                          <Switch
                            v-model="instance_to_edit[field.component_prop_name]"
                            :class="[
                              instance_to_edit[field.component_prop_name] ? 'bg-blue' : 'bg-gray-200',
                              'relative inline-flex flex-shrink-0 h-7 w-12 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue'
                            ]">
                            <span
                              aria-hidden="true"
                              :class="[
                                instance_to_edit[field.component_prop_name] && $store.state.portfolio.ui_options?.language == 'ar'
                                  ? '-translate-x-5'
                                  : instance_to_edit[field.component_prop_name]
                                    ? 'translate-x-5'
                                    : 'translate-x-0',
                                'pointer-events-none inline-block h-6 w-6 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'
                              ]" />
                          </Switch>
                          <span class="text-common-grey">{{ field.label }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="w-fit">
                    <div class="flex items-center scale-125 justify-center mt-1.5 ml-5">
                      <button
                        v-if="all_required_fields_filled"
                        class="flex items-center justify-start flex-none w-7 h-7 p-1.5 mr-1 transition-opacity border rounded-md hover:bg-gray-200"
                        @click="handleApplyInstanceEdit(item)">
                        <Check class="w-5 h-5 text-green-500" aria-hidden="true" />
                      </button>
                      <button
                        class="flex items-center justify-start flex-none w-7 h-7 p-1.5 transition-opacity rounded-md border hover:bg-gray-200"
                        @click="instance_to_edit = {}">
                        <X class="w-5 h-5 text-red-500" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="component_to_add?.id == sub_component.id" class="flex flex-col w-full gap-2 mt-2">
                <div class="w-full">
                  <div class="grid grid-cols-2 gap-x-4 gap-y-4">
                    <div
                      v-for="field in sub_component.fields"
                      :key="field.component_prop_name"
                      class="col-span-1"
                      :class="{ 'col-span-2': field.column_full_span }">
                      <TextInput
                        v-if="field.type == 'text_input'"
                        :validate-on-input="true"
                        :value="new_instance[field.component_prop_name]"
                        label=""
                        :classes="'w-full'"
                        input-classes="appearance-none block w-full px-3 py-2 h-[40px] border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
                        name="name"
                        type="text"
                        :placeholder="field.label"
                        @update:modelValue="
                          (e) => {
                            new_instance[field.component_prop_name] = e
                          }
                        " />

                      <MultiSelectInput
                        v-else-if="field.type == 'multi_select'"
                        v-model:current-items="new_instance[field.component_prop_name]"
                        :is-box-background="true"
                        :value="new_instance[field.component_prop_name]"
                        name="selected_options"
                        :items="field.options"
                        :disabled="field.disabled"
                        :label-attr="field.label_attr"
                        :value-attr="field.value_attr"
                        :allow-null="true"
                        class="w-full flex flex-col justify-between"
                        :label="field.label"
                        input-classes="sm:text-sm appearance-none font-medium text-gray-700 text-left block w-full px-3 py-[6px] border border-gray-300 rounded-md shadow-sm bg-white focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light dark:border-dark-divider-border dark:bg-dark-box-background"
                        :selection-text="null"
                        :placeholder="field.label"
                        :show-label="false" />

                      <SelectGroupDropDownMenu
                        v-else-if="field.type == 'multi_select_search'"
                        :adjust-height="true"
                        :disabled="
                          field.default_value ||
                            new_instance['dataSource'] == 'specific_record' ||
                            new_instance['dataSource'] == 'another_record'
                        "
                        :value="new_instance[field.component_prop_name]"
                        name="selected_options_2"
                        :items="
                          field.filter_based_on
                            ? field.options.filter((o) => o[field.filter_field] == new_instance[field.filter_based_on])
                            : field.options
                        "
                        :create-group-action="field.create_group_action"
                        :object-type="sub_component?.settings?.object_type_confined"
                        :return-value="false"
                        :allow-null="true"
                        :is-box-background="true"
                        input-classes="sm:text-sm appearance-none font-medium text-gray-700 text-left block w-full px-3 py-2 h-[40px] border border-gray-300 rounded-md shadow-sm focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light dark:border-dark-divider-border dark:bg-dark-box-background"
                        :placeholder="`${field.label}`"
                        :label-attr="field.label_attr"
                        :value-attr="field.value_attr"
                        class="w-full flex flex-col justify-between"
                        @groupSelection="
                          ($event) => {
                            new_instance[field.component_prop_name] = $event
                          }
                        " />

                      <SelectDropDownMenu
                        v-show="field.filter_based_on ? new_instance[field.filter_based_on] : true"
                        v-else-if="field.type == 'select'"
                        v-model:current-item="new_instance[field.component_prop_name]"
                        :disabled="field.disabled"
                        name="select_input"
                        :allow-null="false"
                        :items="
                          field.filter_based_on
                            ? field.options.filter((o) => o[field.filter_field] == new_instance[field.filter_based_on])
                            : field.options
                        "
                        :create-group-action="field.create_group_action"
                        :object-type="sub_component.settings?.object_type_confined"
                        :is-box-background="true"
                        :label-attr="field.label_attr"
                        :value-attr="field.value_attr"
                        class="w-full flex flex-col justify-between"
                        :class="[
                          {
                            'opacity-40 pointer-events-none': field.filter_based_on
                              ? field.options.filter((o) => o[field.filter_field] == new_instance[field.filter_based_on]).length == 0
                              : field.options.length == 0
                          }
                        ]"
                        :placeholder="field.label"
                        :label="field.label"
                        :show-label="false"
                        :use-floating-label="false"
                        :input-classes="`w-full sm:text-sm appearance-none h-10 font-medium text-gray-700 text-left block px-1 py-2 h-[40px] rounded-lg shadow-sm bg-white focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light`" />

                      <div
                        v-else-if="
                          field.type == 'company_select' &&
                            (field.linked_field ? new_instance[field.linked_field] == field.linked_field_value_to_show : true)
                        "
                        class="w-full flex flex-col justify-between">
                        <CompaniesSelect
                          :open-to-top="false"
                          :short-king="true"
                          :alternate-design="false"
                          :type-filter="field.type_filter"
                          :multi-select="false"
                          :companies="new_instance[field.component_prop_name] ? [new_instance[field.component_prop_name]] : []"
                          :disabled="field.disabled"
                          :label="field.label"
                          @changed="
                            ($event) => {
                              if (!field.disabled) new_instance[field.component_prop_name] = $event[0]?.id
                            }
                          " />
                      </div>
                      <div v-else-if="field.type == 'date_input'" class="rounded-md shadow-sm">
                        <DatePicker
                          v-model="new_instance[field.component_prop_name]"
                          :is-dark="$store.state.ui.darkMode"
                          class="bg-white dark:bg-dark-screen-background"
                          is-inline
                          mode="date"
                          :popover="{ visibility: 'click' }">
                          <template #default="{ inputValue, inputEvents }">
                            <div class="relative">
                              <svg
                                fill="none"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                class="absolute w-4 h-full mx-2 text-gray-600 pointer-events-none">
                                <path d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                              </svg>

                              <input
                                id="f_date"
                                :value="inputValue"
                                :placeholder="field.label"
                                autocomplete="off"
                                class="bg-light-box-background dark:bg-dark-box-background w-full h-10 px-10 pl-8 pr-2 transition ease-in-out border rounded-lg outline-none text-light-body-text dark:text-dark-body-text border-light-divider-border dark:border-dark-divider-border focus:ring-1 focus:outline-none focus:ring-light-brand-blue dark:focus:ring-dark-brand-blue focus:border-light-brand-blue dark:focus:border-dark-brand-blue duration-side-menu-transition-duration"
                                v-on="inputEvents">
                            </div>
                          </template>
                        </DatePicker>
                      </div>

                      <div
                        v-else-if="field.type == 'color_selector'"
                        class="flex space-x-2 items-center !w-full flex-col justify-between z-30">
                        <div class="mr-2">
                          {{ field.label }}:
                        </div>
                        <ColorPickerList v-model:current-item="new_instance[field.component_prop_name]" :label="field.label" />
                      </div>

                      <ActionsFilter
                        v-else-if="field.type == 'actions_filter'"
                        :hide-range-selection="component_to_add.id.includes('calendar')"
                        :workspace-record="field.workspace_record"
                        :dynamic-data-source="field.dynamic_data_source"
                        :selected-actions="new_instance?.view_by"
                        @change="new_instance[field.component_prop_name] = $event" />
                      <div v-else-if="field.type == 'boolean'" class="flex items-center mt-4 gap-x-2">
                        <Switch
                          v-model="new_instance[field.component_prop_name]"
                          :class="[
                            new_instance[field.component_prop_name] ? 'bg-blue' : 'bg-gray-200',
                            'relative inline-flex flex-shrink-0 h-7 w-12 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue'
                          ]">
                          <span
                            aria-hidden="true"
                            :class="[
                              new_instance[field.component_prop_name] && $store.state.portfolio.ui_options?.language == 'ar'
                                ? '-translate-x-5'
                                : new_instance[field.component_prop_name]
                                  ? 'translate-x-5'
                                  : 'translate-x-0',
                              'pointer-events-none inline-block h-6 w-6 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'
                            ]" />
                        </Switch>
                        <span class="text-common-grey">{{ field.label }}</span>
                      </div>
                    </div>
                  </div>
                  <div id="component_filters" class="w-full h-full" />
                </div>
                <div class="w-full flex justify-between mt-2">
                  <button
                    class="btn-cancel w-fit"
                    @click="
                      () => {
                        component_to_add = null
                        close()
                      }
                    ">
                    <X class="w-5 h-5" aria-hidden="true" />
                    {{ $t("Cancel") }}
                  </button>
                  <button v-if="all_required_fields_filled" class="btn-primary w-fit" @click="handleCreateInstance">
                    <Check class="w-5 h-5" aria-hidden="true" />
                    {{ $t("Add") }} {{ sub_component.name }}
                  </button>
                </div>
              </div>
            </DisclosurePanel>
          </div>
        </Disclosure>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from "@/components/shared/Modal.vue"
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue"
import { Activity, Eye, EyeOff, X, Check, Plus, Trash2, Pencil } from "lucide-vue-next"
import { Switch } from "@headlessui/vue"
import SelectGroupDropDownMenu from "@/components/shared/SelectGroupDropDownMenu.vue"
import { DatePicker } from "v-calendar"
import MultiSelectInput from "@/components/shared/MultiSelectInput.vue"
import TextInput from "@/components/shared/TextInput.vue"
import ComboBoxInput from "@/components/shared/ComboBoxInput.vue"
import { ALL_COMPONENTS } from "@/store/constants/all_components"
import CompaniesSelect from "@/components/shared/CompaniesSelect.vue"
import ActionsFilter from "@/components/shared/action-interactions-filters/ActionsFilter.vue"
import Logo from "@/components/shared/Logo.vue"
import Avatar from "@/components/shared/Avatar.vue"
import { v4 as uuidv4 } from "uuid"
import SelectDropDownMenu from "@/components/shared/SelectDropDownMenu.vue"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"
import ColorPickerList from "@/components/shared/ColorPickerList.vue"
import PortfolioOverviewGroupIcon from "@/components/shared/icons/PortfolioOverviewGroupIcon.vue"
import Customer360GroupIcon from "@/components/shared/icons/Customer360GroupIcon.vue"
import InsightsGroupIcon from "@/components/shared/icons/InsightsGroupIcon.vue"
import RevenueGroupIcon from "@/components/shared/icons/RevenueGroupIcon.vue"
import ExpansionGroupIcon from "@/components/shared/icons/ExpansionGroupIcon.vue"
import LifecycleGroupIcon from "@/components/shared/icons/LifecycleGroupIcon.vue"
import ResourcesGroupIcon from "@/components/shared/icons/ResourcesGroupIcon.vue"
import AIComponentsIcon from "@/components/shared/icons/AIComponentsIcon.vue"

export default {
  components: {
    Modal,
    Check,
    X,
    PortfolioOverviewGroupIcon,
    Customer360GroupIcon,
    InsightsGroupIcon,
    RevenueGroupIcon,
    ExpansionGroupIcon,
    LifecycleGroupIcon,
    ResourcesGroupIcon,
    AIComponentsIcon,
    DatePicker,
    SelectGroupDropDownMenu,
    ColorPickerList,
    Switch,
    ActionsFilter,
    Avatar,
    CompaniesSelect,
    Logo,
    Disclosure,
    Activity,
    DisclosureButton,
    DisclosurePanel,
    SelectDropDownMenu,
    Pencil,
    Trash2,
    Plus,
    Eye,
    EyeOff,
    MultiSelectInput,
    TextInput,
    ComboBoxInput
  },
  props: {
    componentList: {
      type: Array,
      required: true
    },

    createNewInstance: {
      type: Function,
      required: true
    },
    editInstance: {
      type: Function,
      required: true
    },

    changeInstanceHidden: {
      type: Function,
      required: true
    },

    deleteInstance: {
      type: Function,
      required: true
    },
    searchTerm: null
  },
  emits: ["openEditForm", "openAddNewForm"],
  data() {
    return {
      has_bottom_overlay: false,
      component_to_add: null,
      new_instance: { label: "", metricName: "" },
      instance_to_edit: { id: null, component_id: null },
      instance_to_replace: null,
      search_term: "",
      full_records: {},
      item_to_delete: null,
      delete_modal_open: false
    }
  },

  computed: {
    components_to_edit_in_form() {
      return ["text", "notes", "image", "video", "assets", "team_card"]
    },
    all_required_fields_filled() {
      const required_field_names = this.componentList
        .find((s_c) => s_c.id == this.component_to_add?.id)
        ?.fields?.filter((f) => f.required && (f.linked_field ? this.new_instance[f.linked_field] == f.linked_field_value_to_show : true))
        ?.map((f) => f.component_prop_name)
      let all_filled = true
      required_field_names?.forEach((field_name) => {
        if (Array.isArray(this.new_instance[field_name]) ? !this.new_instance[field_name].length : !this.new_instance[field_name]) {
          all_filled = false
        }
      })
      return all_filled
    }
  },
  watch: {
    componentList: {
      deep: true,
      handler() {
        this.getAllRecordsInInstances()
      }
    },

    component_to_add() {
      this.new_instance = {}

      if (this.component_to_add) {
        this.component_to_add.fields.forEach((f) => {
          if (f.component_prop_name == "label") {
            this.new_instance["label"] = this.component_to_add.name
          }
          if (f.type == "multi_select") {
            this.new_instance[f.component_prop_name] = f.options?.map((o) => o[f.value_attr])
          }
          if (f.default_value) {
            this.new_instance[f.component_prop_name] = f.default_value
          }
        })
      }
    },
    searchTerm() {
      setTimeout(() => {
        this.checkForOverlay()
        if (this.searchTerm) {
          this.componentList?.forEach((s_c) => {
            if (this.$refs[`${s_c.id}Disclosure`] && this.$refs[`${s_c.id}Disclosure`][0]) {
              this.$refs[`${s_c.id}Disclosure`][0]?.click()
            }
          })
        } else {
          this.componentList?.forEach((s_c) => {
            if (this.$refs[`${s_c.id}Disclosure2`] && this.$refs[`${s_c.id}Disclosure2`][0]) {
              this.$refs[`${s_c.id}Disclosure2`][0]?.click()
            }
          })
        }
      }, 100)
    }
  },

  created() {
    this.getAllRecordsInInstances()
    this.register_listeners()
  },
  activated() {
    this.register_listeners()
  },

  deactivated() {
    this.unregister_listeners()
  },
  unmounted() {
    this.unregister_listeners()
  },

  methods: {
    unregister_listeners() {
      // this.$emitter.off(ALL_EMITTERS.OPEN_INSTANCE_EDIT_FORM)
      // this.$emitter.off(ALL_EMITTERS.OPEN_INSTANCE_REPLACE_FORM)
      // this.$emitter.off(ALL_EMITTERS.COMPONENT_FORM_SUBMITTED)
    },
    register_listeners() {
      this.$emitter.on(ALL_EMITTERS.OPEN_INSTANCE_EDIT_FORM, (instance) => {
        const item_id = this.getItemId(instance)

        this.handleInstanceToEdit(instance, item_id)
        setTimeout(() => {
          this.$refs[`${item_id}Disclosure`] ? this.$refs[`${item_id}Disclosure`][0]?.click() : null

          document.getElementById(`${item_id}Disclosure`)?.scrollIntoView()

          document.getElementById(`${item_id}Disclosure`)?.click()
        }, 500)
      })

      this.$emitter.on(ALL_EMITTERS.OPEN_INSTANCE_REPLACE_FORM, (instance) => {
        const item_id = this.getItemId(instance)

        this.handleInstanceToReplace(instance, item_id)
      })

      this.$emitter.on(ALL_EMITTERS.COMPONENT_FORM_SUBMITTED, (item) => {
        setTimeout(() => {
          document.getElementById(`${item.component_type}Disclosure`)?.scrollIntoView()
          document.getElementById(`${item.component_type}Disclosure`)?.click()
        }, 500)
      })
    },
    getItemId(instance) {
      const component_type = instance.props.component_type
      if (component_type == "journey") {
        return `${instance.props.component_props.journey}_journey`
      }
      if (component_type == "graph") {
        return `${instance.props.component_props.graph}_graph`
      }
      if (component_type == "rollup") {
        return `${instance.props.component_props.rollup}_rollup`
      }
      if (component_type == "score") {
        return `${instance.props.component_props.score}_score`
      }
      if (component_type == "record_table") {
        return `${instance.props.component_props.objectType}_${component_type}`
      }
      return component_type
    },
    getAllRecordsInInstances() {
      this.componentList?.forEach((sub_component) => {
        sub_component.instances.forEach((instance) => {
          if (instance.props?.component_props?.linkedRecord) {
            if (!this.full_records[instance.props.component_props.linkedRecord]) {
              this.$store.dispatch("data/getRecord", instance.props.component_props.linkedRecord).then((res) => {
                this.full_records[instance.props.component_props.linkedRecord] = res.data
              })
            }
          }
        })
      })
    },
    handleScroll() {
      this.checkForOverlay()
    },
    checkForOverlay() {
      setTimeout(() => {
        const list_container = this.$refs?.listContainer
        if (list_container?.scrollTop + list_container?.offsetHeight + 5 >= list_container?.scrollHeight) {
          this.has_bottom_overlay = false
        } else {
          this.has_bottom_overlay = true
        }
      }, 200)
    },
    addNewInstanceClick(component_to_add) {
      if (this.components_to_edit_in_form.includes(component_to_add.component_type)) {
        this.$emit("openAddNewForm", { component_type: component_to_add.component_type })
      } else {
        this.component_to_add = component_to_add

        this.instance_to_edit = {}
      }
    },
    handleInstanceToEdit(instance, component_id) {
      if (this.components_to_edit_in_form.includes(instance.props.component_type)) {
        this.$emit("openEditForm", {
          instance,
          component_type: instance.props.component_type
        })
      } else {
        this.component_to_add = null
        this.instance_to_edit = {
          component_id: component_id,
          id: instance.id,
          ...instance.props.component_props
        }
      }
    },
    handleInstanceToReplace(instance) {
      this.instance_to_replace = instance
    },
    handleCreateInstance() {
      if (this.instance_to_replace) {
        //Replace component
        const item = { ...this.instance_to_replace }
        const component_props = this.new_instance
        if (this.component_to_add?.component_type == ALL_COMPONENTS.FORECASTING_METRIC) {
          component_props["metricName"] = this.component_to_add?.id
        }
        let props = {
          component_type: this.component_to_add?.component_type,
          component_reference: `${this.instance_to_replace.component_reference}`,
          hidden: false,
          component_props
        }

        if (this.component_to_add.settings?.object_type_confined) {
          props.component_props["objectType"] = this.component_to_add.settings?.object_type_confined
        }
        if (this.component_to_add.settings?.parent_field_value) {
          props.component_props[this.component_to_add.settings?.parent_field_prop_name] = this.component_to_add.settings?.parent_field_value
        }

        item["props"] = props

        this.editInstance(item)
        this.component_to_add = null
      } else {
        //Create new component
        const unique_id = uuidv4()
        const item = { id: unique_id }
        const component_props = this.new_instance
        if (this.component_to_add?.component_type == ALL_COMPONENTS.FORECASTING_METRIC) {
          component_props["metricName"] = this.component_to_add?.id
        }
        let props = {
          component_type: this.component_to_add?.component_type,
          component_reference: `${unique_id}`,
          hidden: false,
          component_props
        }

        if (this.component_to_add.settings?.object_type_confined) {
          props.component_props["objectType"] = this.component_to_add.settings?.object_type_confined
        }
        if (this.component_to_add.settings?.parent_field_value) {
          props.component_props[this.component_to_add.settings?.parent_field_prop_name] = this.component_to_add.settings?.parent_field_value
        }

        item["props"] = props

        this.createNewInstance(item)
        this.component_to_add = null
      }
    },
    handleApplyInstanceEdit(item) {
      const instance_to_edit_copy = this.$utils.clone(this.instance_to_edit)

      delete instance_to_edit_copy.id
      delete instance_to_edit_copy.component_id
      const new_item = {
        ...item,
        props: {
          ...item.props,
          component_props: { ...item.props?.component_props, ...instance_to_edit_copy }
        }
      }
      this.editInstance(new_item)
      this.instance_to_edit = {}
    },

    handleInstanceVisibleClick(item) {
      const new_item = { ...item, props: { ...item.props, hidden: !item.props.hidden } }
      this.changeInstanceHidden(new_item)
    },

    handleInstanceleDelete(item) {
      this.delete_modal_open = true
      this.item_to_delete = item
      // this.deleteInstance(item)
    }
  }
}
</script>
